import { Fragment, useContext } from 'react';
import MembershipBenefits from './components/MembershipBenefits';
import Categories from './components/Categories';
import EthicsCode from './components/EthicCodes';
import CommitCodeEthic from './components/CommitCodeEthic';
import CertificateSample from './components/CertificateSample';
import NeedHelp from './components/NeedHelp';
import TitleSection from './components/TitleSection';
import HowToApply from './components/HowToApply';
import { AuthContext } from '../../Contexts/AuthContext';


const members = [
    {
        alt: 'Stairs-Up',
        icon: "/assets/services/3/benefits/Stairs-Up.png",
        title: "Use of “FWPI Accredited Training Provider” Title & Badge",
        description: "Showcase your accreditation status across all marketing, website, and promotional materials to build trust and recognition."
    },
    {

        alt: 'Mortarboard',
        icon: "/assets/services/3/benefits/Mortarboard.png",
        title: "FWPI Accreditation Certificate",
        description: "Receive an official certificate confirming your institution’s compliance with FWPI quality and operational standards."
    },
    {

        alt: 'Protect',
        icon: "/assets/services/3/benefits/Protect.png",
        title: "Enhanced Credibility & Student",
        description: "Position your academy as a nationally approved and industry-recognised training provider."
    },
    {

        alt: 'Facial-Recognition',
        icon: "/assets/services/3/benefits/Facial-Recognition.png",
        title: "Increased Demand for Education & Training",
        description: "Accreditation boosts your market appeal, attracting students seeking reputable and recognised qualifications."
    },
    {

        alt: 'User-Shield',
        icon: "/assets/services/3/benefits/User-Shield.png",
        title: "Nationally Recognised Quality Mark",
        description: "Earn the FWPI quality seal, a symbol of excellence and professionalism in fitness and wellness education."
    },
    {

        alt: 'Discount',
        icon: "/assets/services/3/benefits/Discount.png",
        title: "Revenue Growth Potential",
        description: "Attract more enrolments, expand course offerings, and open doors to new business opportunities."
    },
    {

        alt: 'Voucher',
        icon: "/assets/services/3/benefits/Voucher.png",
        title: "Better Career Opportunities for Graduates",
        description: "FWPI recognition enhances employability, making your graduates more competitive in the job market."
    },
    {

        alt: 'Workflow',
        icon: "/assets/services/3/benefits/Workflow.png",
        title: "Official Directory Listing",
        description: "Get featured in the FWPI Training Provider Directory, making it easier for students and partners nationwide to find and connect with you."
    }
];
const points = [
    "Compliance with FWPI’s academic, ethical, and operational standards",
    "Qualified faculty/trainers with relevant industry expertise",
    "A structured curriculum with clear learning outcomes",
    "Commitment to learner success and professional development"
]

const categoriesData = [
    "Fitness & Personal Training",
    "Nutrition & Wellness",
    "Sports Nutrition",
    "Martial Arts & Combat Fitness",
    "Yoga & Mind-Body Sciences",
    "Special Population Fitness",
    "Pre & Post-Natal Fitness",
    "Youth Fitness",
    "Aerobics Instruction",
    "Pilates Instructor Training",
    "Functional Training",
    "Face Yoga & Holistic Practices",
    "Physique Transformation Coaching",
    "Strength & Conditioning",
];


const codeOfEthicsPoints = [
    {
        number: 1,
        title: "Educational Quality & Standards",
        content: [
            "Ensure all training materials and curriculum are current, relevant, and aligned with industry best practices and regulatory requirements.",
            "Maintain consistent and high standards in course delivery, ensuring learning objectives are clearly defined and met.",
            "Regularly review and update course content based on feedback, industry changes, and emerging knowledge."
        ],
        isExpanded: true
    },
    {
        number: 2,
        title: "Qualified Faculty",
        content: [
            "Employ faculty who possess the necessary academic qualifications, professional certifications, and relevant practical experience in their fields.",
            "Ensure faculty are continuously engaged in professional development to maintain expertise and instructional effectiveness.",
            "Provide a supportive environment that encourages faculty excellence, ethical conduct, and student engagement."
        ],
        isExpanded: true
    },
    {
        number: 3,
        title: "Honesty & Transparency",
        content: [
            "Present all courses, faculty credentials, and outcomes truthfully in marketing and communications.",
            "Avoid exaggerated claims about course benefits, job placements, or guaranteed results."
        ],
        isExpanded: true
    },
    {
        number: 4,
        title: "Fair Admissions & Equal Opportunity",
        content: [
            "Provide fair and non-discriminatory access to programs regardless of gender, age, religion, disability, or background.",
            "Maintain transparent admission requirements and selection criteria."
        ],
        isExpanded: true
    },
    {
        number: 5,
        title: "Student-Centered Approach",
        content: [
            "Prioritise the well-being and success of students by providing adequate resources, support services, and academic guidance.",
            "Establish accessible channels for student feedback and use this input for continuous improvement of services and programs.",
            "Handle all student grievances and appeals promptly, fairly, and confidentially."
        ],
        isExpanded: true
    },
    {
        number: 6,
        title: "Confidentiality & Data Protection",
        content: [
            "Strictly adhere to all applicable data protection laws and ethical guidelines regarding the collection, storage, and use of student and staff information.",
            "Ensure the confidentiality of all personal, academic, and sensitive data is maintained at all times.",
            "Obtain explicit consent before sharing any student information with third parties, except as required by law."
        ],
        isExpanded: true
    },
    {
        number: 7,
        title: "Ethical Assessment & Certification",
        content: [
            "Implement assessment methods that are fair, valid, and reliable, accurately reflecting a student's achievement of learning outcomes.",
            "Ensure certification and qualifications are only awarded to students who have demonstrably met all required standards and competencies.",
            "Prevent and address all forms of academic dishonesty, including cheating and plagiarism, with consistent and clear policies."
        ],
        isExpanded: true
    },
    {
        number: 8,
        title: "Safe & Supportive Learning Environment",
        content: [
            "Maintain a physical and virtual learning environment that is safe, healthy, and free from harassment, discrimination, and intimidation.",
            "Foster a culture of respect, tolerance, and open communication among all students, faculty, and staff.",
            "Provide reasonable accommodations for students with disabilities to ensure equitable participation."
        ],
        isExpanded: true
    },
    {
        number: 9,
        title: "Compliance & Integrity",
        content: [
            "Operate in full compliance with all local, national, and international laws, regulations, and industry standards applicable to training providers.",
            "Avoid any activity that constitutes a conflict of interest, bribery, or corruption, and maintain the highest level of institutional integrity.",
            "Ensure all financial records, reporting, and accreditation documentation are accurate and truthful."
        ],
        isExpanded: true
    },
    {
        number: 10,
        title: "Continuous Improvement",
        content: [
            "Commit to an ongoing process of self-evaluation and external review to enhance the quality of all programs and operations.",
            "Invest in infrastructure, technology, and staff development to support evolving educational needs and best practices.",
            "Set measurable goals for improvement in student outcomes, operational efficiency, and adherence to the Code of Ethics."
        ],
        isExpanded: true
    },
];

const GrowWithFWPI = () => {

    const { token, setIsLoginModal } = useContext(AuthContext);

    return (
        <Fragment>
            <section className="w-full bg-gradient-radial pt-32 pb-12 lg:py-40 text-center">
                <div className="container mx-auto px-4 lg:px-15 flex flex-col items-center gap-10">
                    <p className="text-lg sm:text-2xl lg:text-3xl text-center font-bold font-urbanist text-stone-300">
                        Become a Training Provider – Get Recognised. Grow with FWPI.
                    </p>

                    <div className="w-full lg:w-2/3 flex flex-col items-center">
                        <img className="w-full lg:w-[80%] h-auto lg:h-[25rem] object-cover rounded-tl-xl md:rounded-tl-2xl rounded-[5rem] md:rounded-[8rem] border-2 border-white" src="/assets/services/3/hero.jpg" alt="service-hero-section" />
                    </div>

                    <div className="w-full lg:w-2/3 flex flex-col items-center lg:items-start text-center gap-8">
                        <h1 className="text-3xl sm:text-5xl lg:text-5xl font-bold font-urbanist text-white capitalize leading-tight">
                            Are You a Fitness Academy or Institute Delivering Quality Education?
                        </h1>
                        <p className="text-sm sm:text-base lg:text-xl font-urbanist font-semibold text-stone-300">
                            FWPI invites credible and ethical training institutions to become FWPI-Accredited Training Providers. Our accreditation adds national recognition, quality assurance, and trust to your certifications — helping your learners gain confidence and industry respect.
                        </p>
                    </div>
                </div>
            </section>
            <MembershipBenefits
                title={'As an FWPI Accredited Training Provider or Studio, you will'}
                description='As an FWPI Accredited Training Provider or Studio, you will'
                buttonName={"Join Now"}
                benefits={members}
                pathname={!!token ? '/my-profile' : '/training-provider/create'}
                onClick={() => {
                    if (!token) {
                        setIsLoginModal(true);
                    }
                }}
            />
            <section className="w-full bg-gradient-radial py-12 lg:py-15">
                <div className="container mx-auto px-5 lg:px-15">
                    <div className='flex flex-col items-center pb-6'>
                        <TitleSection
                            title="Who Can Apply for FWPI Training Provider Accreditation?"
                            description={`FWPI invites applications from <b>reputable institutions, academies, training providers, and fitness/wellness organizations</b> that are committed to delivering <b>high-quality, ethical, and industry-relevant education</b> in the fitness, wellness sector.`}
                        />
                    </div>

                    <div className="w-100 flex flex-col items-center">
                        <div className="w-full lg:w-2/3 p-6 sm:p-10 lg:p-16 border border-white rounded-[2.5rem] lg:rounded-[5rem] rounded-tl-xl lg:rounded-tl-2xl shadow-lg">
                            <h2
                                className="w-100 text-3xl sm:text-4xl lg:text-5xl font-bold font-urbanist text-white text-center mb-10 lg:mb-10">
                                Eligible institutions should demonstrate
                            </h2>
                            <div className="w-100 px-5 lg:px-28 flex flex-col items-center gap-6">
                                <ul className="space-y-5 lg:space-y-1 text-left list-outside list-disc text-white">
                                    {
                                        points.map((point) => {
                                            return (
                                                <li className="gap-4">
                                                    <p className="text-neutral-300 text-base sm:text-lg">
                                                        {point}
                                                    </p>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Categories
                title={'Programs That Can Be Endorsed by FWPI'}
                taglines={'FWPI will endorse Professional Qualifications and Continuing Professional Development (CPD) Programs across a wide range of disciplines, including.'}
                tags={categoriesData}
            />

            <section className="w-full bg-gradient-radial py-10 lg:py-5 lg:px-40 px-4">
                <div className="container mx-auto">
                    <div className='bg-white rounded-2xl shadow-md flex flex-row items-center justify-between gap-2 px-2 lg:px-5 py-4 lg:py-5'>
                        <div className='flex flex-col items-center justify-center h-[5.5rem] w-[25rem] md:w-52 bg-[#0D0E15] rounded-3xl rounded-tl-lg md:border-r-8 border-r-zinc-600'>
                            <img className='h-10 md:h-12 w-10 md:w-12 object-contain' src="/assets/services/3/double-check.png" alt="verified-member" />
                        </div>
                        <h2 className="text-black text-[0.7rem] sm:text-xl lg:text-xl font-semibold font-urbanist text-left pl-1 lg:pl-3">
                            Any institution that meets FWPI’s quality, compliance, and ethical benchmarks is welcome to apply for accreditation and gain the advantage of national recognition, credibility, and professional trust.
                        </h2>
                    </div>

                </div>
            </section>

            <section className="bg-gradient-radial">
                <div className="flex justify-center items-center flex-col w-[75%] mx-auto  ">
                    <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-white text-center md:mt-10">
                        How to Apply?
                    </h2>

                </div>
                <HowToApply />
            </section>

            <EthicsCode
                title={`FWPI Training Provider –\nCode of Ethics`}
                description='All FWPI Accredited Training Providers must uphold the highest standards of integrity, quality, and professionalism in delivering education. This Code of Ethics sets the principles and expectations for maintaining accreditation and protecting the credibility of FWPI-recognised qualifications.'
                items={codeOfEthicsPoints}
            />

            <CommitCodeEthic
                title={'Commit to Code of Ethics'}
                description={'All Gym Facilities / Studios must agree to follow the FWPI Code of Ethics, promoting professionalism, authenticity, responsibility, and recognition.'}
                buttonName={'Apply Now'}
                pathname={!!token ? '/my-profile' : '/training-provider/create'}
                onClick={() => {
                    if (!token) {
                        setIsLoginModal(true);
                    }
                }}
            />
            <CertificateSample
                imageContainerClass={'px-0 py-0 bg-transparent'}
                imageContainerRadiusClass={'rounded-[0.7rem]'}
                imageRadiusClass={'rounded-[0.7rem]'}
                imagePath='/assets/services/3/certificate.jpg'
            />
            <NeedHelp />
        </Fragment>
    );
}

export { GrowWithFWPI };
